import { fontsCssFileUrl, googleFonts, helveticaCssUrl, wixMadeforFontsUrl } from '@wix/fonts-data';
import React from 'react';

const fontsCssUrls = [fontsCssFileUrl, wixMadeforFontsUrl, helveticaCssUrl, googleFonts];

export const FontsCssLoader: React.FC = () => {
  return (
    <>
      {fontsCssUrls.map(href => (
        <link key={href} rel="stylesheet" href={href} />
      ))}
    </>
  );
};
